import axiosInstance from './AxiosInstance';
import { getApiUrl } from '../utils/ApiUtils';

export async function uploadAvatar(userId, file) {
    const formData = new FormData();
    formData.append('avatar', file);
    const url = getApiUrl(`users/${userId}/avatar`);
    const response = await axiosInstance.post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
}

export async function deleteAvatar(userId) {
    const url = getApiUrl(`users/${userId}/avatar`);
    const response = await axiosInstance.delete(url);
    return response.data;
}
